import { render, staticRenderFns } from "./amend.vue?vue&type=template&id=294d7fee&scoped=true"
import script from "./amend.vue?vue&type=script&lang=ts"
export * from "./amend.vue?vue&type=script&lang=ts"
import style0 from "./amend.vue?vue&type=style&index=0&id=294d7fee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294d7fee",
  null
  
)

export default component.exports